<template>
  <div class="seomain">
    <ul class="tab-tilte two">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <div class="tab-content tab-content-list">
      <div v-show="cur == 0" class="st-list-box pan-1">
        <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          error-text="点击重新加载"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="st-list" v-for="(v, k) in stlist0" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.sku }}</div>
            </div>
            <div class="st-list-main">
              <p>产品名称：{{ v.stname }}</p>
              <p>品牌：{{ v.brand }}</p>
              <p>型号：{{ v.model }}</p>
              <p>配置：{{ v.deploy }}</p>
              <p
                v-if="v.supplier_id != 0"
                @click="
                  activeId = v.id;
                  sShow = true;
                "
              >
                供应商：{{ v.sname }}
              </p>
              <p
                v-else
                @click="
                  activeId = v.id;
                  sShow = true;
                "
              >
                供应商：<span class="red">{{ v.sname || "点击选择供应商" }}</span>
              </p>
              <p
                @click="
                  activeId = v.id;
                  codeShow = true;
                "
              >
                中标代码：{{ v.code }}
              </p>
              <p>中标价格：{{ v.q }}</p>
            </div>
            <div class="st-list-bottom">
              <p
                class="st-opt-btn"
                @click="
                  activeId = v.id;
                  show_detail_box(v.id);
                "
              >
                立即维护
              </p>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 1" class="st-list-box pan-2">
        <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          error-text="点击重新加载"
          finished-text="没有更多信息"
          @load="onLoad"
        >
          <div class="st-list" v-for="(v, k) in stlist1" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.sku }}</div>
            </div>
            <div class="st-list-main">
              <p>产品名称：{{ v.stname }}</p>
              <p>品牌：{{ v.brand }}</p>
              <p>型号：{{ v.model }}</p>
              <p>配置：{{ v.deploy }}</p>
              <p
                @click="
                  activeId = v.id;
                  sShow = true;
                "
              >
                供应商：{{ v.sname }}
              </p>
              <p
                @click="
                  activeId = v.id;
                  codeShow = true;
                "
              >
                中标代码：{{ v.code }}
              </p>
              <p>中标价格：{{ v.q }}</p>

              <p>上次维护时间：{{ v.lasttime ? v.lasttime : "暂无数据" }}</p>
              <p>上次维护价格：{{ v.lastprice ? v.lastprice + "元" : "暂无数据" }}</p>
              <p>上次采购价格：{{ v.last_buy_price ? v.last_buy_price + "元" : "暂无数据" }}</p>
            </div>
            <div class="st-list-bottom">
              <p
                class="st-opt-btn"
                @click="
                  activeId = v.id;
                  show_detail_box(v.id);
                "
              >
                再次维护
              </p>
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <van-dialog v-model="show" show-cancel-button @confirm="edit_st2()">
      <div class="mix-detail-box" v-if="dialogData">
        <h2>SKU：{{ dialogData.sku }}</h2>
        <p>产品名称：{{ dialogData.stname }}</p>
        <!-- <p>产品名称：{{ dialogData.products_name }}</p> -->
        <p>品牌：{{ dialogData.brand }}</p>
        <p>型号：{{ dialogData.model }}</p>
        <p>配置：{{ dialogData.deploy }}</p>
        <el-input v-model="dialog_num" placeholder="请输入价格"></el-input>
      </div>
    </van-dialog>

    <van-popup v-model="sShow" position="bottom" :style="{ height: '40%' }">
      <van-picker
        show-toolbar
        :columns="snameList"
        value-key="snameLabel"
        @confirm="onConfirm"
        @cancel="sShow = false"
      />
    </van-popup>

    <!-- 中标代码 选择器 -->
    <van-popup v-model="codeShow" position="bottom" :style="{ height: '40%' }">
      <van-picker
        title="中标代码"
        show-toolbar
        :columns="codeList"
        @confirm="onCodeConfirm"
        @cancel="codeShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      tabTitle: ["待维护", "已维护"],
      cur: 0,
      dialog_num: "",
      show: !1,
      stlist0: [],
      stlist1: [],
      oneinfo: {},
      sShow: false,
      snameList: {}, // 供应商列表
      codeShow: false,
      codeList: [],
      error: false,
      activeId: "",
    };
  },
  watch: {},
  computed: {
    dialogData() {
      let result = this["stlist" + this.cur].filter((item) => item.id == this.activeId)[0];
      return result;
    },
  },
  methods: {
    show_detail_box: function(e) {
      if (this.dialogData.supplier_id == 0) {
        this.$toast.fail("请先选择供应商");
        return;
      }
      this.show = !0;
      this.dialog_num = "";
      // this.$post(this.$api.stGetCaigoucView, { id: e }).then((res) => {
      //   this.oneinfo = res.data;
      //   this.activeId = res.data.id;
      //   this.show = !0;
      // });
    },
    edit_st2: function() {
      let t = this;
      if (this.$isEmpty(this.dialog_num)) {
        return this.$toast.fail("请先填写内容");
      }
      let priceReg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
      if (!priceReg.test(this.dialog_num)) {
        return this.$toast.fail("请输入正确的价格");
      }
      t.edit_st();
    },
    edit_st: function() {
      let list = this["stlist" + this.cur];
      const index1 = list.findIndex((item) => item.id == this.activeId);

      var ss = {
        id: this.activeId,
        price: this.dialog_num,
        products_id: this.dialogData.products_id,
        supplier_id: this.dialogData.supplier_id,
        code: list[index1].code,
      };
      console.log(this.activeId);
      let t = this;
      this.$post(this.$api.stGetCaigoucEdit, ss).then((res) => {
        if (res.code == 200) {
          this.$toast.success("修改成功");
          this.get_st_list(t.cur);
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    async get_st_list(e) {
      this.stlist0 = [];
      this.stlist1 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("purchasec_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
      }
    },
    changeActiveIndex(value) {
      this.cur = value;
      window.sessionStorage.setItem("purchasec_activeIndex", value);
    }, // 分页
    async onLoad() {
      try {
        let result = await this.$post(this.$api.stGetCaigoucList, {
          status: this.cur,
          page: this.page,
        });

        if (result.data.length == 0) return (this.finished = true);
        // 进行操作
        this["stlist" + this.cur].push(...result.data);
        // 设置中标代码选择
        this.codeList = result.data[0].code_lists;
        this.snameList = this.$formatKeyValue(result.data[0].sname_list, "snameValue", "snameLabel");
        // 操作完成
        this.page += 1;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.error = true;
      }
    },
    // 选择器确定的回调
    onConfirm(value) {
      this.sShow = false;
      let list = this["stlist" + this.cur];
      const index1 = list.findIndex((item) => item.id == this.activeId);
      console.log(index1);
      this["stlist" + this.cur] = list.filter((item, index) => {
        if (index1 == index) {
          item.supplier_id = value.snameValue;
          item.sname = value.snameLabel;
        }
        return item;
      });
    },
    /**
     * 确定中标代码的回调
     */
    onCodeConfirm(value) {
      this.codeShow = false;
      let list = this["stlist" + this.cur];
      const index1 = list.findIndex((item) => item.id == this.activeId);
      this["stlist" + this.cur] = list.filter((item, index) => {
        if (index1 == index) {
          item.code = value;
        }
        return item;
      });
    },
  },
  created() {
    this.init();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "采购价格维护" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.tab-content-list {
  padding-top: 50px;
}
.two li {
  width: 50%;
}
</style>
